const DATA_TEST_IDS = {
  fragmentsPinCodeFragment: 'authentication__common_pin-code-fragment',
} as const;

export default DATA_TEST_IDS;
